const getChildrenTextContent = (children=[]) =>
{
	return children.map(node => ( node.children ) ? getChildrenTextContent(node.children) : node.text).join('')
}

export default
{
	functional: true,

	props:
	{
		tag:
		{
			type:    String,
			default: 'span',
		},
	},

	render(h, { props, slots })
	{
		const $slots = slots()

		return h
		(
			props.tag,
			( getChildrenTextContent($slots.default) + '' )
				.split(/(\r\n|\n\r|\r|\n)/g)
				.reduce
				(
					(accumulator, string) =>
					{
						if ( !Array.isArray(accumulator) )
						{
							return [ accumulator, h('br'), string ]
						}

						return accumulator.concat([ h('br'), string ])
					}
				)
		)
	},
}